export default from './Uploader';



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/components/Uploader/index.js